<template>
  <div class="upOption">
    <el-dialog :title="title"
               v-model="dialogVisible"
               :append-to-body="true"
               :close-on-click-modal='false'
               width="514px">
      <div>
        <div class="name">选项名称</div>
        <div>
          <el-input
            placeholder="请输入选项名称"
            type="text"
            readonly
            disabled
            v-model="date.optionname"
          ></el-input>
        </div>
        <div class="name">选项（每行对应一个选项）</div>
        <div>
          <el-input
            placeholder="添加选项"
            type="textarea"
            class="textarea-option"
            :autosize="{ minRows: 2 }"
            v-model="date.options"
          ></el-input>
        </div>
        <div class="name">选项分类</div>
        <div>
          <el-input :value="date.category && date.category.category" readonly disabled></el-input>
        </div>
        <div class="name">排序</div>
        <div>
          <el-input
            placeholder="请输入排序"
            type="number"
            v-model="date.orders"
            readonly
            disabled
          ></el-input>
        </div>
      </div>
      <div class="option-button">
        <el-button size="mini" class="new-file" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary"
          @click="yesOption"
          v-loading="isLoading"
          element-loading-text="数据加载中"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <div id="upOption"></div>
  </div>
</template>

<script>
import { openapiAddoptions, openapiUpdateoptions } from '@/port/admins/wordbook'
export default {
  name: "upOption",
  props: ['fileNav'],
  data () {
    return {
      dialogVisible: false,
      title: '新增选项',
      isUp: false,
      indexSort: '',
      isLoading: false,
      date: {
        optionname: '',
        options: '',
        categoryId: '',
        orders: ''
      }
    }
  },
  watch: {
    dialogVisible (val) {
      if (!val) {
        this.title = '新增选项';
        this.isUp = false;
        this.indexSort = '';
        this.isLoading = false;
        this.date = {
          optionname: '',
          options: '',
          categoryId: '',
          orders: ''
        };

      }
    }
  },
  methods: {
    yesOption () {
      if (this.isLoading) return
      for (let i in this.date) {
        if (!this.date[i] && this.date[i] === '') {
          this.$message({
            type: 'error',
            message: '请输入完整'
          })
          return false;
        }
      }
      let fun = this.isUp ? openapiUpdateoptions : openapiAddoptions;
      let val = JSON.parse(JSON.stringify(this.date));
      try {
        val.options = JSON.stringify(val.options.split('\n'));
      }
      catch (e) { console.log(e) }
      this.isLoading = true;
      console.log('修改参数', val)
      if (this.$route.query.space && localStorage.getItem('spaceid')) val.spaceid = localStorage.getItem('spaceid')
      else if (this.$route.query.upace && localStorage.getItem('upaceid')) val.upaceid = localStorage.getItem('upaceid')
      const obj = JSON.parse(JSON.stringify(val))
      delete obj.name
      delete obj.category
      fun(obj).then(res => {
        if (res.code === 0) {
          this.dialogVisible = false;
          /*
                      let retVal = JSON.parse(JSON.stringify(val));
                      retVal.options = retVal.options.join(' ; ');
                      let date = {
                        date: retVal,
                        index: this.indexSort
                      };
          */
          this.$message({ type: 'success', message: res.msg });
          this.$emit('upoption');
          // this.$emit('upoption', date);
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
        this.isLoading = false;
      }).catch(error => { console.log(error) })
    },
    viewDialog (title = { title: '新增选项', navIndex: '' }, val, index) {
      if (title && title.title) this.title = title.title;
      if (val) {
        this.isUp = true;
        this.date = val;
      }
      if (index) this.indexSort = index;
      this.dialogVisible = true;
      this.styleFun();
    },
    styleFun () {
      let str = '<style>' +
        '.upOption .el-dialog__header{padding:17px 20px;background: #F7F7F7;}' +
        '.upOption .el-dialog__title, .upSort .el-dialog__headerbtn .el-dialog__close{color: #000000;}' +
        '.textarea-option textarea {max-height:200px;}' +
        '</style>';
      try {
        document.getElementById('upOption').innerHTML = str;
      }
      catch (e) { console.log('css赋值错误', e) }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  border-radius: 14px;
  overflow: hidden;
  .el-dialog__body {
    padding: 0 20px 30px;
  }
  /*.new-file:hover,*/
  /*.new-file:visited,*/
  /*.new-file:focus {*/
  /*  background: #ffffff;*/
  /*  border: 1px solid #999999;*/
  /*}*/
}

.option-button {
  text-align: right;
  padding-top: 40px;
}
.name {
  padding-top: 20px;
  padding-bottom: 5px;
  color: #333333;
  font-size: 14px;
}

</style>
